export const allowanceTypes = {
  boxRentalAllowance: 'box_rental',
  carAllowance: 'car_allowance',
  computerRentalAllowance: 'computer_rental',
  mobilePhoneAllowance: 'mobile_phone',
  perDiemAllowance: 'per_diem',
  housingAllowance: 'housing_allowance',
};
